/* eslint-disable */
import { ref } from 'vue';
import { $api } from '@/services';

const error = ref(null);
const loading = ref(false);

export async function createStaff(data: any) {
	error.value = null;
	try {
		const res = await $api.staff.createStaff(data);
		return res?.data;
	} catch (err) {
		error.value = err?.response?.data?.errors_by_field || err.message;
	} finally {
		loading.value = false;
	}
}

export function useCreateStaff() {
	return { createStaff__error: error, loading, createStaff };
}
